// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609070004/js/" + chunkId + "." + {"44":"32efaa7e","225":"25677eb2","481":"0c35ee68","486":"d070509c","770":"e8d08a78"}[chunkId] + ".0.6916783906407965.chunk.js";
};